
import { defineComponent, ref, computed } from "vue";
import ViewHeader from "@/components/ViewHeader.vue";
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import SelectPriceTypeView from "@/views/SelectPriceTypeView.vue";

export default defineComponent({
  components: {
    ViewHeader,
    SelectPriceTypeView,
  },
  async setup() {
    const showSelectPriceTypeView = ref(false);
    const store = useStore();
    const router = useRouter();
    var clubId = computed(() => store.state.clubId);
    var clubSelected = computed(() => clubId.value > 0);
    function scanVoucher() {
      store.commit("setClubInOrder", clubId.value);      
      router.push({
        name: "clubScan",
        params: {
          clubId: clubId.value,
        },
      });
    }
    function manualOrder() {
      store.commit("setClubInOrder", clubId.value);
      router.push({
        name: "clubProducts",
        params: {
          clubId: clubId.value,
        },
      });
    }
    return { clubSelected, scanVoucher, manualOrder, showSelectPriceTypeView };
  },
});
